import React from 'react'

import { P } from '@mxenabled/mxui'

import type { SxProps } from '@mui/material'
import CardContent from '@mui/material/CardContent'

import ClientConfigurableCta from './ClientConfigurableCta'

import type { Beat } from '../../../types/CommonBeat'

interface DescriptionMUIProps {
  beat: Beat
  hasFullWidthImage?: boolean
  sx?: SxProps
}

export const DescriptionMUI: React.FC<DescriptionMUIProps> = ({ beat, hasFullWidthImage, sx }) => {
  const { html_description } = beat

  return (
    <CardContent
      sx={{
        p: 0,
        '&:last-child': {
          pb: 0,
        },
        ...sx,
      }}
    >
      <P
        dangerouslySetInnerHTML={{ __html: html_description! }}
        sx={{
          m: 0,
          mb: 4,
          px: 0,
          ...(hasFullWidthImage && { px: 16 }),
        }}
        variant="subtitle2"
      />
      <ClientConfigurableCta beat={beat} />
    </CardContent>
  )
}
